<template>
  <div>
    <el-breadcrumb separator="/" style="margin-bottom: 20px;">
      <el-breadcrumb-item><a style="font-weight: 700; color: #333;">通知消息</a></el-breadcrumb-item>
    </el-breadcrumb>
    <el-card v-loading="queryInfo.loading">
      <div v-if="queryInfo.tableData.length > 0">
        <div class="notification-list" >
          <div class="notification-c">
            <div class="notification-item cursor" v-for="(item, index) in queryInfo.tableData" :key="index" @click="handleNext(item, index)">
              <div style="margin-right: 20px;">
                <el-badge is-dot class="item" :max="99" :hidden="item.status == 2">
                  <img src="../../assets/images/kjj.png" alt="">
                </el-badge>
              </div>
              <div>
                <div class="notification-title">{{ item.pushHeadine }} </div>
                <div style="font-size: 12px; color: #999; margin-top: 10px">{{ item.pushDate }}</div>
              </div>
            </div>
          </div>
        </div>
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="queryInfo.page"
          :page-sizes="[10, 20, 30, 50]"
          layout="total, sizes, prev, pager, next, jumper"
          :total="queryInfo.total">
        </el-pagination>
      </div>
      <div v-else class="empty" >
        <img src="../../assets//images/empty.png" alt="" v-if="!queryInfo.loading">
      </div>
    </el-card>

    <el-dialog title="通知详情" width="800px" :visible.sync="dialogVisible" :modal-append-to-body='false' :close-on-click-modal="false" >
      <div style="padding: 0 20px 80px; box-sizing: boreder-box;">
        <div style="text-align: center; color: #333; font-size: 20px">{{ info.pushHeadine }}</div>
        <div style="text-align: right; margin: 20px 0 40px; font-size: 14px; color: #999">{{ info.pushDate }}</div>
        <div v-html="info.pushContent"></div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { increasedMessagePushGetWebPage, increasedMessagePushRead } from '@/api/increased'

export default {
  data () {
    return {
      dialogVisible: false,
      info: {},
      queryInfo: {
        page: 1,
        size: 10,
        total: 0,
        tableData: [],
        loading: false
      }
    }
  },
  created() {
    this.getList()
  },
  methods: {
    handleNext(row, index) {
      // this.info = row
      row.status = 2
      this.$router.push({ path: '/notification/details', query: { id: row.id } })
      // this.dialogVisible = true
      // if (row.status == 2) return false
      increasedMessagePushRead({ id: row.id }).then(res => {
        if (res.code === '000') {
          this.$store.dispatch('updateCount')
        }
      })
    },
    // 页面列表数据
    getList () {
      const params = {
        pageNo: this.queryInfo.page,
        pageSize: this.queryInfo.size
      }
      this.queryInfo.loading = true
      increasedMessagePushGetWebPage(params).then(res => {
        this.queryInfo.loading = false
        if (res.code === '000') {
          this.$store.dispatch('updateCount')
          this.queryInfo.tableData = res.result.records
          this.queryInfo.total = res.result.total
        }
      })
    },
    // 条数
    handleSizeChange(val) {
      this.queryInfo.pageSize = val
      this.queryInfo.page = 1
      this.getList()
    },
    // 页数
    handleCurrentChange (val) {
      this.queryInfo.page = val
      this.getList()
    }
  },
  beforeRouteLeave(to, from, next) {
    if (to.name == 'notification/details') {
      from.meta.keepAlive = true
    } else {
      from.meta.keepAlive = false
    }
    next()
  }
}
</script>

<style lang="less" scoped>
  .notification-list {
    .notification-c {
      padding: 0 10px;
      box-sizing: border-box;
    }
    .notification-item {
      border-bottom: 1px solid #e5e6eb;
      padding: 20px 0;
      display: flex;
      align-items: center;
    }
    .notification-title{
      position: relative;
      font-size: 16px;
      color: #333;
    }
  }
  .empty {
      width: 100%;
      height: calc(100vh - 180px);
      display: flex;
      align-items: center;
      justify-content: center;
    }
</style>
